export default {
    process: {
        label: "生产进度",
        empty: "暂无生产进度",
    },
};
